import BrandLogo from "/static/images/tenants/samsung/Samsung_Orig_Wordmark_WHITE_RGB.png";
import { samsungContent } from "../brandContent/samsungBrandContent";
import { samsungPrize } from "../brandPrize/samsungPrize";
import { samsung } from "../brandThemes/samsung";

// Samsung board (clean rebuild) — served at /samsung, feature code in
// features/samsung. Fully isolated from the old samsung-racing board via its
// own `gameStyle` ("samsung" → styles/themes/samsung.scss, scoped to
// `.theme-samsung.samsung`).
//
// Data binding matches samsung-racing: Elgiganten tenant (shared kiosk
// auto-login user) + Forza Motorsport data (`fm8`). See the note in
// SAMSUNG-racing.brandvariables.ts for the caveats.
export const SAMSUNGBASE_brandVariables = {
  tenantId: "elgiganten-nbxpa",
  themeId: "samsung",
  gameStyle: "samsung",
  eventCode: "",
  gameType: "fm8",
  brandLogoType: "element",
  brandLogo: BrandLogo,
  brandLogoSize: 400,
  theme: samsung,
  content: samsungContent,
  prize: samsungPrize,

  leaderboardLength: 10,
  disclaimer: null,
};
